import createVueComponent from '../createVueComponent';

const BadgeInfo = createVueComponent('BadgeInfoIcon', [
  [
    'path',
    {
      d: 'M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z',
      key: '3c2336',
    },
  ],
  ['line', { x1: '12', x2: '12', y1: '16', y2: '12', key: '1y1yb1' }],
  ['line', { x1: '12', x2: '12.01', y1: '8', y2: '8', key: '110wyk' }],
]);

export default BadgeInfo;
